import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useLazyQuery } from '@apollo/client';
import { GET_METHOD_OF_PAYMENT } from '../gql/getMop';
import { setAppMode } from '../redux/AppModeState/AppModeState.actions';
import { useDispatch } from 'react-redux';
import { AppMode } from '../redux/AppModeState/AppModeState.types';
import { getMopOnFileSuccess } from '../redux/MopOnFileState/MopOnFileState.actions';
import { transformRecurlyMopDetailsToPaymentMethodsData } from '../utils/TransformUtils';
import { setSelectedMop } from '../redux/MopOnFileState/MopOnFileState.actions';
import { useEffect } from 'react';
import { sendNewRelicMessage } from '../utils/NewRelicUtils';
import { APOLLO_COMMERCE_CONTEXT, PaymentMethodType } from '@chegg/commerce-utils';
import { paymentMethodsSelector } from '../redux/MopOnFileState/MopOnFileState.selectors';
import { useAppSelector } from '../hooks/useAppSelector';
export var MOCK_GET_MOP = {
  myMethodsOfPayment: [{
    id: 'v46d9uqqpir1',
    isBackup: false,
    isPrimary: true,
    mopHolderName: 'ecom test',
    mopInfo: {
      card: {
        binCountry: 'ZZ',
        cardType: 'VISA',
        expMonth: 4,
        expYear: 2025,
        last4: '1111'
      },
      type: PaymentMethodType.CREDIT_CARD,
      venmo: {
        username: undefined
      }
    },
    updatedAt: '2024-06-21T18:35:21.000Z',
    billingAddress: {
      addressLine1: '3990 Freedom Cir',
      addressLine2: null,
      city: 'Santa Clara',
      state: 'CA',
      postalCode: '95054',
      country: 'US',
      phone: null
    },
    user: {
      uuid: '78f6ae0e-ee5b-4e6b-9ffd-6cc31be9c13c'
    },
    valid: true
  }]
};
var MOP_TYPES_TO_FILTER = new Set([PaymentMethodType.APPLE_PAY]);

/**
 * Filters the methods of payment returned by the DGS
 */
var getFilteredMethodsOfPayment = function getFilteredMethodsOfPayment(myMethodsOfPayment) {
  return myMethodsOfPayment.filter(function (_ref) {
    var type = _ref.mopInfo.type;
    return !MOP_TYPES_TO_FILTER.has(type);
  });
};

/**
 * Sets the correct mode based on number of cards on file and returns the response from Get Mop Query
 */
var UseGetRecurlyMopHook = function UseGetRecurlyMopHook() {
  var dispatch = useDispatch();
  var paymentMethods = useAppSelector(paymentMethodsSelector);
  var mops = [];
  var _useLazyQuery = useLazyQuery(GET_METHOD_OF_PAYMENT, {
      context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getMop = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    getMopData = _useLazyQuery2$.data,
    getMopError = _useLazyQuery2$.error;

  // When a new MOP is added, it prepends to the existing list of MOPs in Redux,
  // which updates the paymentMethods state. We use paymentMethods as a dependency
  // to trigger a refetch of the updated MOP details from Recurly,
  // ensuring that the correct properties like isPrimary and isBackup are reflected.
  useEffect(function () {
    void getMop();
  }, [paymentMethods, getMop]);
  useEffect(function () {
    var _getMopData$myMethods;
    if (!getMopData && !getMopError) return;
    var filteredMethodsOfPayment = getFilteredMethodsOfPayment((_getMopData$myMethods = getMopData === null || getMopData === void 0 ? void 0 : getMopData.myMethodsOfPayment) !== null && _getMopData$myMethods !== void 0 ? _getMopData$myMethods : []);
    var mopsOnFile = filteredMethodsOfPayment.length;
    if (getMopError) {
      dispatch(setAppMode({
        mode: AppMode.ADD,
        goBackMode: AppMode.LOADING
      }));
      sendNewRelicMessage('Recurly getMop failed', {
        errors: JSON.stringify(getMopError)
      });
    } else {
      if (mopsOnFile > 0) {
        filteredMethodsOfPayment.forEach(function (mop) {
          mops.push(transformRecurlyMopDetailsToPaymentMethodsData(mop));
        });
        // save Mop into redux
        dispatch(setSelectedMop({
          mop: mops[0]
        }));
        dispatch(setAppMode({
          mode: AppMode.DEFAULT_MOP,
          goBackMode: AppMode.DEFAULT_MOP
        }));
      } else {
        dispatch(setAppMode({
          mode: AppMode.ADD,
          goBackMode: AppMode.ADD
        }));
      }
      dispatch(getMopOnFileSuccess({
        data: mops
      }));
    }
  }, [getMopData, getMopError, dispatch]);
};
export default UseGetRecurlyMopHook;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/hooks/useGetRecurlyMop.js
// module id = 4646
// module chunks = 11